// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"page_pageContainer__Vl4Px","content":"page_content__9aXvE","feedLayout":"page_feedLayout__t69aU"};